import "./spinner.css";

export const Spinner = ({ style }) => {
  return <span class="spnr" style={{ ...style, display: "inherit" }}></span>;
};
